// axios
import axios from 'axios'

// const baseURL = 'https://www.maxwell777.com/dev/api/v1'
const baseURL = process.env.VUE_APP_GLOBALURL

export default axios.create({
  baseURL
  // You can add your headers here
})
